/**
 * Test seam (spec §8.15, M11 tests): Playwright builds large linked pages through the same model
 * functions the UI calls, instead of hundreds of dialog clicks. It exposes nothing a same-origin
 * script could not already reach through the application's own modules.
 */
import { createBlock } from "../blocks/model";
import { addBlockLink, blockTarget } from "../links/model";
import { openHandles } from "../sync/docManager";

export const kssTestSeam = { openHandles, createBlock, addBlockLink, blockTarget };

export function installTestSeam(): void {
  const w = window as unknown as { __kss?: Record<string, unknown> };
  w.__kss = { ...(w.__kss ?? {}), model: kssTestSeam };
}
